import { APIClient } from "../helpers/api_helper";
import { ApiResponse } from "../types/api";

const api = new APIClient();

export interface AppointmentReview {
  id: number;
  tenant_id: number;
  appointment_id: number;
  client_id: number;
  professional_id: number | null;
  unit_id: number | null;
  service_id: number | null;
  rating: number | null;
  comment: string | null;
  reply: string | null;
  replied_at: string | null;
  replied_by_user_id: number | null;
  requested_at: string | null;
  submitted_at: string | null;
  client?: { id: number; name: string } | null;
  professional?: { id: number; name: string } | null;
  service?: { id: number; name: string } | null;
  unit?: { id: number; name: string } | null;
  appointment?: {
    id: number;
    start_datetime: string | null;
    status: string;
  } | null;
  replied_by?: { id: number; name: string } | null;
}

export interface AppointmentReviewWeeklyAlert {
  week_start: string | null;
  previous_average: number;
  current_average: number;
  previous_count: number;
  current_count: number;
  notified_at: string | null;
}

export interface AppointmentReviewSummary {
  average: number | null;
  count: number;
  distribution: Record<number, number>;
  weekly_alert?: AppointmentReviewWeeklyAlert | null;
}

export interface AppointmentReviewListParams {
  rating?: number | null;
  professional_id?: number | null;
  has_comment?: boolean | null;
  has_reply?: boolean | null;
  from?: string | null;
  to?: string | null;
  per_page?: number;
  page?: number;
}

export interface AppointmentReviewListResponse extends ApiResponse<AppointmentReview[]> {
  links?: unknown;
  meta?: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export const listAppointmentReviews = (
  params: AppointmentReviewListParams = {}
): Promise<AppointmentReviewListResponse> =>
  api.get(`/appointment-reviews`, params) as Promise<AppointmentReviewListResponse>;

export const getAppointmentReviewSummary = (
  params: {
    professional_id?: number | null;
    unit_id?: number | null;
    from?: string | null;
    to?: string | null;
  } = {}
): Promise<ApiResponse<AppointmentReviewSummary>> =>
  api.get(`/appointment-reviews/summary`, params);

export const replyToAppointmentReview = (
  reviewId: number,
  reply: string
): Promise<ApiResponse<AppointmentReview>> =>
  api.create(`/appointment-reviews/${reviewId}/reply`, { reply });
